import React, { useEffect, useMemo, useState } from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link, useLocation } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import { DatePicker, Drawer, message, Modal } from 'antd'
import CommonTagsInput from '../../../core/common/Taginput'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../core/data/redux/store'
import { fetchAllProjects, fetchProjectByEmployeeId } from '../../../core/data/redux/projects/project/projectAction'
import Select from 'react-select'
import { getEmployeeByUserId, getEmployees } from '../../../core/data/redux/employee/employeeAction'
import dayjs from 'dayjs'

import { createTask, deleteTask, fetchTaskById, fetchTasks, fetchTasksByEmployeeId, updateTask } from '../../../core/data/redux/projects/task/taskActions'
import { formatDate } from '../../../core/utils/FormatData'
import { convertFileToBase64 } from '../../../core/common/GlobalFunctions/filetobase64'
import { fetchTaskBoards } from '../../../core/data/redux/projects/taskBoard/taskBoardActions'
import { filterByStatus } from '../../../core/utils/filterActiveData'
import { decryptData } from '../../../core/utils/encryptUtils'

const toIdArray = (raw: any): number[] => {
  if (raw == null) return [];
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (Array.isArray(parsed)) return parsed.map((x) => Number(x)).filter(Number.isFinite);
  } catch { }
  const n = Number(raw);
  return Number.isFinite(n) ? [n] : [];
};

const Task = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedPriority, setSelectedPriority] = useState('All');
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [taskId, setTaksId] = useState();
  const [modalType, setModalType] = useState<'edit' | 'create' | ''>('');
  const { user } = useSelector((state: any) => state.auth);
  const { employees } = useSelector((state: any) => state.employee);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const { tasks } = useSelector((state: any) => state.project.task);
  const { selectedTask } = useSelector((state: any) => state.project.task);
  const { projectByEmployeeId : EmployeeProject  } = useSelector((state: any) => state.project.projects);
  const { projectsData } = useSelector((state: any) => state.project.projects);
  const projectByEmployeeId = user?.role_name === "Admin" ?  projectsData : EmployeeProject;
  const { taskBoards } = useSelector((state: any) => state.project.taskBoard);
  const handlePriorityClick = (priority: string) => { setSelectedPriority(priority); };
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);
  const activeProjects = useMemo(() => filterByStatus(projectsData, 'active', 'status'), [projectsData]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredEmployees, setFilteredEmployees] = useState<any[]>([]);

  //Permissions
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd = permissions?.includes("Add") || permissions?.includes("AllowAll");
  const canView = permissions?.includes("View") || permissions?.includes("AllowAll");
  const canEdit = permissions?.includes("Edit") || permissions?.includes("AllowAll");
  const canDelete = permissions?.includes("Delete") || permissions?.includes("AllowAll");

  useEffect(() => {
    if (Array.isArray(projectByEmployeeId) && projectByEmployeeId.length > 0) {
      const firstId = Number(projectByEmployeeId[0]?.project_id);
      setSelectedProjectId(Number.isFinite(firstId) ? firstId : null);
    } else {
      setSelectedProjectId(null);
    }
  }, [projectByEmployeeId]);

  // after you read employeesbyUser / projectByEmployeeId
  const employeeId = Number(employeesbyUser?.employeeId);
  const currentUserId = Number(user?.UserId);

  const visibleProjectIds = useMemo(() => {
    const ids = new Set<number>();
    (projectByEmployeeId ?? []).forEach((p: any) => {
      const isMember = (p?.employee_ids ?? []).map(Number).includes(employeeId);
      const isLead = Number(p?.team_lead_employee_id) === employeeId;
      const isPM = Number(p?.project_manager_employee_id) === employeeId;
      if (isMember || isLead || isPM) ids.add(Number(p?.project_id));
    });
    return ids;
  }, [projectByEmployeeId, employeeId]);


  // --- filter tasks ALSO by selectedProjectId ---
  const filteredTasks = tasks.filter((task: any) => {
    const taskProjectId = Number(task?.Project);

    // visibility checks
    const taskInVisibleProjects = visibleProjectIds.has(taskProjectId);
    const isTeamMember = toIdArray(task?.TeamMemberEmployeeId).includes(employeeId);
    const isCreator = Number(task?.CreatedBy) === currentUserId;

    const visibleToMe = taskInVisibleProjects || isTeamMember || isCreator;

    // optional: further narrow by clicked project card
    const matchesProjectSelection =
      selectedProjectId == null ? true : taskProjectId === Number(selectedProjectId);

    // your existing priority + search
    const matchesPriority =
      selectedPriority === "All" || task?.Priority === selectedPriority;

    const q = searchQuery.toLowerCase();
    const matchesSearch =
      (task?.Title ?? "").toLowerCase().includes(q) ||
      (task?.Description ?? "").toLowerCase().includes(q) ||
      (task?.assignedEmployees ?? []).some((emp: any) =>
        (emp?.name ?? "").toLowerCase().includes(q)
      );

    return visibleToMe && matchesProjectSelection && matchesPriority && matchesSearch;
  });




  const employeeData = employees ? employees : []
  const activeEmploeeData = useMemo(
    () => filterByStatus(employees ?? [], 'active', 'employee_status'),
    [employees]
  );

  const [taskFormData, setTaskFormData] = useState<any>({
    Title: '',
    TotalHours: '',
    DueDate: dayjs(),
    Project: '',
    TeamMemberEmployeeId: [],
    Tags: [],
    Status: '',
    Priority: '',
    Visibility: 'Private',
    Description: '',
    file: null,
  });
  const [formErrors, setFormErrors] = useState<any>({
    Title: '',
    TotalHours: '',
    DueDate: '',
    Project: '',
    TeamMemberEmployeeId: '',
    Status: '',
    Priority: '',
    Visibility: '',
    Description: '',
    file: '',
  });

  const resetForm = () => {
    setTaskFormData({
      Title: '',
      TotalHours: '',
      DueDate: dayjs(),
      Project: '',
      TeamMemberEmployeeId: [],
      Tags: [],
      Status: '',
      Priority: '',
      Visibility: 'Private',
      Description: '',
      file: null,
    });
    setFormErrors({
      Title: '',
      TotalHours: '',
      DueDate: '',
      Project: '',
      TeamMemberEmployeeId: '',
      Status: '',
      Priority: '',
      Visibility: '',
      Description: '',
      file: '',
    });
  };

  useEffect(() => {
    if (!taskBoards.length) dispatch(fetchTaskBoards());
  }, [dispatch, taskBoards.length])

  useEffect(() => {
    if (modalType === 'edit' && taskId && selectedTask?.TaskID === taskId) {
      const newFormData = {
        Title: selectedTask.Title || '',
        TotalHours: selectedTask.TotalHours || '',
        DueDate: dayjs(selectedTask.DueDate) || dayjs(),
        Project: selectedTask.Project || '',
        TeamMemberEmployeeId: JSON.parse(selectedTask.TeamMemberEmployeeId || '[]'),
        Tags: JSON.parse(selectedTask.Tags || '[]'),
        Status: selectedTask.Status || '',
        Priority: selectedTask.Priority || '',
        Visibility: selectedTask.Visibility || 'Private',
        Description: selectedTask.Description || '',
        file: null,
      };
      const selectedProject = activeProjects.find(
        (project: any) => project.project_id === Number(selectedTask.Project)
      );

      if (selectedProject && selectedProject.employee_ids) {
        const projectEmployees = activeEmploeeData.filter((emp: any) =>
          selectedProject.employee_ids.includes(emp.EmployeeID)
        );
        setFilteredEmployees(projectEmployees);
      } else {
        setFilteredEmployees([]);
      }

      if (selectedTask.AttachmentPath) {
        const fileName = selectedTask.AttachmentPath.split("/").pop() || "unknown file";
        convertFileToBase64(selectedTask.AttachmentPath)
          .then((base64: any) => {
            setTaskFormData({
              ...newFormData,
              file: {
                name: fileName,
                data: base64,
              },
            });
          })
          .catch((error: any) => {
            console.error('Error converting file to base64:', error);
          });
      } else {
        setTaskFormData(newFormData);
      }
    }
  }, [modalType, taskId, selectedTask?.TaskID]);


  const filteredTaskBoards = useMemo(
    () => taskBoards.filter((b: any) => b.Project === Number(taskFormData.Project)),
    [taskBoards, taskFormData.Project]
  );

  // Selected project (by id from form)
  const selectedProject = useMemo(() => {
    if (!taskFormData?.Project) return undefined;
    return activeProjects.find((p: any) => p.project_id === Number(taskFormData.Project));
  }, [activeProjects, taskFormData?.Project]);

  // Keep filteredEmployees in sync with selected project's employee_ids
  useEffect(() => {
    const ids: number[] | null | undefined = selectedProject?.employee_ids;

    if (Array.isArray(ids) && ids.length > 0) {
      const allowed = new Set(ids.map(Number));
      const projectEmployees = activeEmploeeData.filter((emp: any) =>
        allowed.has(Number(emp.EmployeeID))
      );

      // 3a) setFilteredEmployees only if different
      setFilteredEmployees((prev) => {
        const sameLength = prev.length === projectEmployees.length;
        const sameItems =
          sameLength &&
          prev.every((e, i) => e.EmployeeID === projectEmployees[i].EmployeeID);
        return sameItems ? prev : projectEmployees;
      });

      // 3b) trim selected members only if it actually changes
      setTaskFormData((prev: any) => {
        const current: number[] = Array.isArray(prev.TeamMemberEmployeeId)
          ? prev.TeamMemberEmployeeId
          : [];
        const trimmed = current.filter((id) => allowed.has(Number(id)));
        return trimmed.length === current.length
          ? prev
          : { ...prev, TeamMemberEmployeeId: trimmed };
      });
    } else {
      // No members on project: only update if needed
      setFilteredEmployees((prev) => (prev.length ? [] : prev));
      setTaskFormData((prev: any) =>
        prev.TeamMemberEmployeeId?.length
          ? { ...prev, TeamMemberEmployeeId: [] }
          : prev
      );
    }
  }, [selectedProject, activeEmploeeData]);


  useEffect(() => {
    dispatch(fetchAllProjects());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getEmployees());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchTasks());
  }, [dispatch]);

  useEffect(() => {
    if (employeeId) {
      dispatch(fetchProjectByEmployeeId({ employeeId }));
    }
  }, [dispatch, employeeId]);

  useEffect(() => {
    if (!employeesbyUser?.employeeId) {
      dispatch(getEmployeeByUserId({ userId: user?.UserId }));
    }
  }, [dispatch, employeesbyUser, user]);

  useEffect(() => {
    if (taskId) {
      dispatch(fetchTaskById(taskId));
    }
  }, [dispatch, taskId, modalType]);


  useEffect(() => {
    if (employeeId) {
      dispatch(fetchTasksByEmployeeId(employeeId));
    }
  }, [dispatch, employeeId]);

  const validateForm = () => {
    const errors: any = {};
    if (!taskFormData.Title) {
      errors.Title = 'Title is required';
    }
    if (!taskFormData.TotalHours) {
      errors.TotalHours = 'Total Hours is required';
    } else if (isNaN(taskFormData.TotalHours)) {
      errors.TotalHours = 'Total Hours must be a number';
    }
    if (!taskFormData.DueDate || !dayjs(taskFormData.DueDate).isValid()) {
      errors.DueDate = 'Valid Due Date is required';
    }
    if (!taskFormData.Project) {
      errors.Project = 'Project selection is required';
    }
    if (taskFormData.TeamMemberEmployeeId.length === 0) {
      errors.TeamMemberEmployeeId = 'At least one team member is required';
    }
    if (!taskFormData.Status) {
      errors.Status = 'Task Label is required';
    }
    if (!taskFormData.Priority) {
      errors.Priority = 'Priority is required';
    }
    if (!taskFormData.Visibility) {
      errors.Visibility = 'Visibility is required';
    }
    if (taskFormData.Tags.length === 0) {
      errors.Tags = 'Please type & press Enter to add a tag';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleProjectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleInputChange(e, 'Project'); // sets taskFormData.Project
    // Filtering + trimming will happen in the useEffect tied to selectedProject
  };



  const handleInputChange = (e: any, field: string, type?: string) => {
    if (type === "multiSelect") {
      const updatedValue = e.map((emp: any) => emp.value);
      setTaskFormData((prevState: any) => ({
        ...prevState,
        [field]: updatedValue,
      }));
    } else if (type === "file") {
      const file = e.target.files[0];
      if (file) {
        setTaskFormData((prevState: any) => ({
          ...prevState,
          file: file,
        }));
      }
    } else if (type === "tags") {
      setTaskFormData((prevState: any) => ({
        ...prevState,
        Tags: e,
      }));
    } else {
      const { value } = e.target;
      setTaskFormData((prevState: any) => ({
        ...prevState,
        [field]: value,
      }));
    }

    setFormErrors((prevErrors: any) => ({
      ...prevErrors,
      [field]: '',
    }));
  };
  const handleFileDelete = () => {
    setTaskFormData((prevState: any) => ({
      ...prevState,
      file: null,
    }));
  };
  const showModal = (type: 'edit' | 'create') => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType('');
    resetForm()
  };
  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    const updatedFormData = {
      ...taskFormData,
      CreatedBy: modalType === 'create' ? user.UserId : undefined,
      ModifiedBy: modalType === 'edit' ? user.UserId : undefined,
      DueDate: dayjs(taskFormData.DueDate).format('YYYY-MM-DD'),
      file:
        modalType === 'create'
          ? taskFormData.file
          : taskFormData.file instanceof File
            ? taskFormData.file
            : undefined,
    };
    try {
      let result;
      if (modalType === 'create') {
        result = await dispatch(createTask(updatedFormData)).unwrap();
      } else if (modalType === 'edit') {
        result = await dispatch(updateTask({ taskId, ...updatedFormData })).unwrap();
      }
      if (result) {
        message.success(result.message);
        dispatch(fetchTasks())
        resetForm();
      } else {
        message.error(result?.payload.error);
      }
      handleCancel();
    } catch (error) {
      message.error('An error occurred');
    }
  };
  const handleDeleteTask = (taskId: number) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this task?',
      content: 'This action cannot be undone.',
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const result = await dispatch(deleteTask(taskId));
          if (result.meta.requestStatus === 'fulfilled') {
            await dispatch(fetchTasks());
            message.success('Task deleted successfully');
          } else {
            message.error(result.payload?.error || 'Failed to delete task');
          }
        } catch (error) {
          message.error('Something went wrong');
        }
      },
    });
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById('modal-datepicker');
    return modalElement ? modalElement : document.body;
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Tasks</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Projects</li>
                  <li className="breadcrumb-item active">
                    Tasks
                  </li>
                </ol>
              </nav>
            </div>
            <div className="my-xl-auto right-content d-flex">
              {canAdd && (
                <div className="mb-2">
                  <button
                    onClick={() => showModal('create')}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Task
                  </button>
                </div>
              )}
              <div className="head-icons ms-2 mb-0">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-4">
              <div>
                {projectByEmployeeId?.map((project: any, index: any) => {
                  const isActive = Number(selectedProjectId) === Number(project?.project_id);
                  return (
                    <div
                      className="card"
                      key={index}
                      onClick={() => setSelectedProjectId(Number(project?.project_id))}
                      style={{ cursor: 'pointer', ...(isActive ? { boxShadow: '0 0 0 2px rgba(13,110,253,.4) inset' } : {}) }}
                    >
                      <div className="card-body">
                        {/* ⬇️ your existing UI stays exactly the same */}
                        <div className="d-flex align-items-center pb-3 mb-3 border-bottom">
                          <div className="flex-shrink-0 me-2">
                            <ImageWithBasePath src="assets/img/social/project-01.svg" alt="Img" />
                          </div>
                          <div>
                            <h6 className="mb-1">
                              <div>{project?.project_name}</div>
                            </h6>
                            <div className="d-flex align-items-center">
                              <span>{project.total_tasks} tasks</span>
                              <span className="mx-1">
                                <i className="ti ti-point-filled text-primary" />
                              </span>
                              <span>{project.completed_tasks} Completed</span>
                            </div>
                          </div>
                          <div>
                            <h5 className="position-absolute top-0 end-0 mt-3 me-3 text-danger fw-bold">
                              {project?.priority}
                            </h5>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="mb-3">
                              <span className="mb-1 d-block">Deadline</span>
                              <p className="text-dark">{formatDate(project?.end_date)}</p>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="mb-3">
                              <span className="mb-1 d-block">Value</span>
                              <p className="text-dark">{project?.price_type}{project?.project_value}</p>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="mb-3">
                              <span className="mb-1 d-block">Project Lead</span>
                              <h6 className="fw-normal d-flex align-items-center">
                                <img
                                  className="avatar avatar-xs rounded-circle me-1"
                                  src={project?.team_lead_pictureurl ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                  alt="Img"
                                />
                                {project?.team_lead_name}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div className="bg-light p-2">
                          <div className="row align-items-center">
                            <div className="col-6">
                              <span className="fw-medium d-flex align-items-center">
                                <i className="ti ti-clock text-primary me-2" />
                                Total {project?.total_hours} Hrs
                              </span>
                            </div>
                            <div className="col-6">
                              <div>
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                  <small className="text-dark">{project?.progress}% Completed</small>
                                </div>
                                <div className="progress progress-xs">
                                  <div
                                    className="progress-bar bg-info"
                                    role="progressbar"
                                    style={{ width: `${project?.progress}%` }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-lg-12">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    {/* Priority Tabs */}
                    <ul className="nav nav-pills border p-1 rounded bg-light todo-tabs mb-0">
                      {['All', 'High', 'Medium', 'Low'].map(priority => (
                        <li className="nav-item" key={priority} role="presentation">
                          <button
                            className={`nav-link btn btn-sm btn-icon py-3 d-flex align-items-center justify-content-center w-auto ${selectedPriority === priority ? 'active' : ''
                              }`}
                            onClick={() => handlePriorityClick(priority)}
                          >
                            {priority}
                          </button>
                        </li>
                      ))}
                    </ul>
                    {/* Search Input */}
                    <div style={{ maxWidth: '320px', width: '100%' }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by task name, description or assignee..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                >
                  {/* need to put map here */}
                  <div className="list-group list-group-flush mb-4">
                    {filteredTasks.length > 0 ? (
                      filteredTasks.map((task: any) => (
                        <div
                          key={task.TaskID}
                          className="card shadow-sm border-0 mb-4"
                        >
                          <div className="card-body">
                            {/* Header: Description & Priority */}
                            <div className="d-flex justify-content-between align-items-start flex-column flex-md-row mb-3">
                              <div className="d-flex align-items-start gap-3 flex-grow-1 w-100">
                                {/* <span className="text-muted mt-1">
                                                                    <i className="ti ti-grid-dots fs-" />
                                                                </span> */}
                                <div className="flex-grow-1">
                                  <h5
                                    className="mb-1 text-wrap  fw-semibold"
                                    style={{
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {task?.Description}
                                  </h5>
                                  <p className="mb-0 text-muted small">
                                    <i className="ti ti-calendar me-1" />
                                    {formatDate(task?.DueDate)}
                                  </p>
                                </div>
                              </div>

                              <div className="mt-2 mt-md-0">
                                <span className="badge bg-danger fs-12 text-uppercase">
                                  {task?.Priority}
                                </span>
                              </div>
                            </div>

                            {/* Footer: Tags, Status, Users, Menu */}
                            <div className="d-flex justify-content-between flex-column flex-md-row align-items-start align-items-md-center">
                              <div className="d-flex align-items-center flex-wrap gap-3 mb-3 mb-md-0">
                                <span className="badge bg-light text-dark border">
                                  {task?.Title}
                                </span>
                                {(() => {
                                  const board = taskBoards.find(
                                    (b: any) =>
                                      b.Name === task.Status
                                  );
                                  const badgeColor =
                                    board?.Color || "#6c757d";

                                  return (
                                    <span
                                      className="badge d-inline-flex align-items-center"
                                      style={{
                                        backgroundColor:
                                          badgeColor,
                                        color: "#fff",
                                      }}
                                    >
                                      <i className="fas fa-circle fs-6 me-1" />
                                      {task.Status}
                                    </span>
                                  );
                                })()}
                              </div>

                              <div className="d-flex align-items-center">
                                <div className="avatar-group avatar-group-sm me-2">
                                  {task?.assignedEmployees?.map((emp: any) => (
                                    <span
                                      key={emp.id}
                                      className="avatar avatar-rounded"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title={emp?.name}
                                    >
                                      <img className="border border-white"
                                        src={emp?.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                        alt="img"
                                      />
                                    </span>
                                  )
                                  )}
                                </div>
                                <div className="dropdown">
                                  <Link
                                    to="#"
                                    className="text-muted"
                                    data-bs-toggle="dropdown"
                                    data-bs-placement="top"
                                    title="Action"
                                  >
                                    <i className="ti ti-dots-vertical" />
                                  </Link>
                                  <ul className="dropdown-menu dropdown-menu-end p-2">
                                    <li>
                                      <button
                                        className="dropdown-item rounded-1"
                                        onClick={() => {
                                          showModal("edit");
                                          setTaksId(task.TaskID);
                                        }}
                                      >
                                        <i className="ti ti-edit me-2" />
                                        Edit
                                      </button>
                                    </li>
                                    <li>
                                      <Link
                                        to="#"
                                        className="dropdown-item rounded-1"
                                        onClick={() =>
                                          handleDeleteTask(
                                            task.TaskID
                                          )
                                        }
                                      >
                                        <i className="ti ti-trash me-2" />
                                        Delete
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center mt-5">
                        <Link to="#" className="btn btn-primary">
                          <i className="ti ti-loader me-1" />
                          Task is not available
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* <div className="text-center mb-4">
                                <Link to="#" className="btn btn-primary">
                                    <i className="ti ti-loader me-1" />
                                    Load More
                                </Link>
                            </div> */}
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Task */}

      <Drawer
        title={modalType === "edit" ? "Edit Task" : "Add Task"}
        placement="right"
        width={600}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="modal-body">
            <div className="row">
              <div className="col-12">
                <div className="mb-3">
                  <label className="form-label">Title <span className="text-danger"> *</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={taskFormData.Title}
                    onChange={(e) => handleInputChange(e, 'Title')}
                  />
                  {formErrors.Title && <div className="text-danger">{formErrors.Title}</div>}
                </div>
              </div>
              <div className="col-6">
                <div className="mb-3">
                  <label className="form-label">Total Hours <span className="text-danger"> *</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={taskFormData.TotalHours}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInputChange(e, 'TotalHours');
                      }
                    }}
                    title="Only numbers are allowed"
                  />
                  {formErrors.TotalHours && <div className="text-danger">{formErrors.TotalHours}</div>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Due Date</label>
                  <div className="input-icon-end position-relative">
                    <DatePicker
                      className="form-control datetimepicker"
                      format="DD-MM-YYYY"
                      getPopupContainer={getModalContainer}
                      value={taskFormData.DueDate}
                      onChange={(date) => handleInputChange({ target: { value: date } }, 'DueDate')}
                      placeholder="DD-MM-YYYY"
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                  {formErrors.DueDate && <div className="text-danger">{formErrors.DueDate}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Project</label>
                  <select
                    className="form-control"
                    value={taskFormData.Project}
                    onChange={handleProjectChange}
                  >
                    <option value="">Select Project</option>
                    {activeProjects
                      .sort((a: any, b: any) => a.project_name.localeCompare(b.project_name))
                      .map((project: any) => (
                        <option key={project.project_id} value={project.project_id}>
                          {project.project_name}
                        </option>
                      ))}
                  </select>
                  {formErrors.project_name && <div className="text-danger">{formErrors.project_name}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label me-2">Team Members <span className="text-danger"> *</span></label>

                  <Select
                    isMulti
                    isDisabled={!selectedProject || filteredEmployees.length === 0}
                    placeholder={
                      !taskFormData.Project
                        ? 'Select a project first'
                        : filteredEmployees.length === 0
                          ? 'No members for this project'
                          : 'Select team members'
                    }
                    options={filteredEmployees
                      .sort((a: any, b: any) => a.Name.localeCompare(b.Name))
                      .map((emp: any) => ({
                        value: emp.EmployeeID,
                        label: emp.Name,
                      }))}
                    value={filteredEmployees
                      .filter((emp: any) => taskFormData?.TeamMemberEmployeeId?.includes(emp.EmployeeID))
                      .map((emp: any) => ({ value: emp.EmployeeID, label: emp.Name }))}
                    onChange={(selected: any[]) =>
                      handleInputChange(selected, 'TeamMemberEmployeeId', 'multiSelect')
                    }
                  />

                  {formErrors.TeamMemberEmployeeId && <div className="text-danger">{formErrors.TeamMemberEmployeeId}</div>}
                </div>
              </div>


              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Tag <span className="text-danger"> *</span></label>
                  <CommonTagsInput
                    value={taskFormData.Tags}
                    onChange={(newTags: string[]) => handleInputChange(newTags, 'Tags', 'tags')}
                    placeholder="Add new"
                    className="custom-input-class"
                  />
                  {formErrors.Tags && <div className="text-danger">{formErrors.Tags}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Task Board <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={taskFormData.Status}
                    onChange={(e) => handleInputChange(e, 'Status')}
                  >
                    <option value="">Select Label</option>
                    {filteredTaskBoards?.map((board: any) => (
                      <option key={board.TaskBoardID} value={board.Name}>
                        {board.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.Status && <div className="text-danger">{formErrors.Status}</div>}
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Priority <span className="text-danger"> *</span></label>
                  <select
                    className="form-control"
                    value={taskFormData.Priority}
                    onChange={(e) => handleInputChange(e, 'Priority')}
                  >
                    <option value="">Select Priority</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                  {formErrors.Priority && <div className="text-danger">{formErrors.Priority}</div>}
                </div>
              </div>

              {/* <div className="col-md-12">
                <label className="form-label">Who Can See this Task?</label>
                <div className="d-flex align-items-center mb-3">
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault1"
                      value="Public"
                      checked={taskFormData.Visibility === 'Public'}
                      onChange={(e) => handleInputChange(e, 'Visibility')}
                    />
                    <label className="form-check-label text-dark" htmlFor="flexRadioDefault1">
                      Public
                    </label>
                  </div>
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      value="Private"
                      checked={taskFormData.Visibility === 'Private'}
                      onChange={(e) => handleInputChange(e, 'Visibility')}
                    />
                    <label className="form-check-label text-dark" htmlFor="flexRadioDefault2">
                      Private
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault3"
                      value="Admin Only"
                      checked={taskFormData.Visibility === 'Admin Only'}
                      onChange={(e) => handleInputChange(e, 'Visibility')}
                    />
                    <label className="form-check-label text-dark" htmlFor="flexRadioDefault3">
                      Admin Only
                    </label>
                  </div>
                  {formErrors.Visibility && <div className="text-danger">{formErrors.Visibility}</div>}
                </div>
              </div> */}

              <div className="col-md-12">
                <label className="form-label">Upload Attachment</label>
                <div className="bg-light rounded p-2">
                  <div className="profile-uploader border-bottom mb-2 pb-2">
                    <div className="drag-upload-btn btn btn-sm btn-white border px-3">
                      Select File
                      <input
                        type="file"
                        className="form-control image-sign"
                        onChange={(e) => handleInputChange(e, 'file', 'file')}
                      />
                    </div>
                  </div>
                  {taskFormData.file && (
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <h6 className="fs-12 fw-medium me-1">{taskFormData.file.name}</h6>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Description </label>
                  <textarea
                    className="form-control"
                    rows={2}
                    value={taskFormData.Description}
                    onChange={(e) => handleInputChange(e, 'Description')}
                  />
                  {formErrors.Description && <div className="text-danger">{formErrors.Description}</div>}
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={() => handleCancel()}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSubmit}>
              {modalType === 'edit' ? 'Update New Task' : 'Add New Task'}
            </button>
          </div>
        </form>
      </Drawer >
      {/* /Add Task */}
    </>

  )
}

export default Task
